import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import GalleryPageIamge from "../assets/img/GalleryPageIamge.jpg";
import { motion } from "framer-motion";
import engagementCakeZeppoli from "../assets/img/coverImageGallery/enagementCakeZeppoli.jpg";
import barbieCakeZeppoli from "../assets/img/coverImageGallery/barbieCakeZeppoli.jpg";
import makeupCakeZeppoli from "../assets/img/coverImageGallery/makeupCakeZeppoli.jpg";
import babyShowerCakeZeppoli from "../assets/img/coverImageGallery/babyshowerCakeZeppoli.jpg";
import cartoonCakeZeppoli from "../assets/img/coverImageGallery/cartoonCakeZeppoli.jpg";
import lettersCakeZeppoli from "../assets/img/coverImageGallery/lettersCakeZeppoli.jpg";
import digitsCakeZeppoli from "../assets/img/coverImageGallery/digitsCakeZeppoli.jpg";
import sportsCakeZeppoli from "../assets/img/coverImageGallery/sportsCakeZeppoli.jpg";

function Gallery() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Gallery";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // for gallery filters
  const allCards = [
    {
      category: "Cake",
      image: engagementCakeZeppoli,
      title: "Engagement Cake",
      pageRouteLink: "/engagementcakegallery",
      id: 1,
    },
    {
      category: "Cake",
      image: barbieCakeZeppoli,
      title: "Barbie Cake",
      pageRouteLink: "/barbiecakegallery",
      id: 2,
    },
    {
      category: "Cake",
      image: makeupCakeZeppoli,
      title: "Makeup Cake",
      pageRouteLink: "/makeupcakegallery",
      id: 3,
    },
    {
      category: "Cake",
      image: babyShowerCakeZeppoli,
      title: "Baby Shower Cake",
      pageRouteLink: "/babyshowercakegallery",
      id: 4,
    },
    {
      category: "Cake",
      image: cartoonCakeZeppoli,
      title: "Cartoon Cake",
      pageRouteLink: "/cartooncakegallery",
      id: 5,
    },
    {
      category: "Cake",
      image: lettersCakeZeppoli,
      title: "Letters Cake",
      pageRouteLink: "/letterscakegallery",
      id: 6,
    },
    {
      category: "Cake",
      image: digitsCakeZeppoli,
      title: "Digits Cake",
      pageRouteLink: "/digitscakegallery",
      id: 7,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoli,
      title: "Sports Cake",
      pageRouteLink: "/sportscakegallery",
      id: 8,
    },
  ];

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // downside animation
  const variants6 = {
    hidden: { opacity: 0, y: -100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={GalleryPageIamge}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Gallery</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Gallery</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      <section className="space">
        <div className="container">
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="title-area text-center">
                <span className="sub-title">Cake Gallery</span>
                <h2 className="sec-title">Our Latest Photos Gallery</h2>
              </div>
            </motion.div>
          )}

          <div className="row gy-40 filter-active">
            {allCards.map((card) => (
              <div
                className={`col-xl-3 col-lg-4 col-sm-6 filter-item`}
                key={card.id}
              >
                {isVisible && (
                  <>
                    {card.id === 2 ||
                    card.id === 4 ||
                    card.id === 6 ||
                    card.id === 8 ? (
                      <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={variants5}
                      >
                        <div className="th-product product_style1">
                          <motion.div
                            initial={{
                              opacity: 0,
                            }}
                            whileInView={{
                              opacity: 1,
                              scale: 1,
                              transition: { duration: 2 },
                            }}
                            whileHover={{
                              opacity: 1,
                              scale: 1.05,
                              transition: { duration: 0.1 },
                            }}
                          >
                            <Link to={card.pageRouteLink}>
                              <div
                                style={{
                                  borderRadius: "12px",
                                }}
                                className="mx-15 mb-3"
                              >
                                <img
                                  src={card.image}
                                  style={{ borderRadius: "12px" }}
                                  alt="Zeppoli image"
                                />
                              </div>
                            </Link>
                          </motion.div>
                        </div>
                      </motion.div>
                    ) : (
                      <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={variants6}
                      >
                        <div className="th-product product_style1">
                          <motion.div
                            initial={{
                              opacity: 0,
                            }}
                            whileInView={{
                              opacity: 1,
                              scale: 1,
                              transition: { duration: 2 },
                            }}
                            whileHover={{
                              opacity: 1,
                              scale: 1.05,
                              transition: { duration: 0.1 },
                            }}
                          >
                            <Link to={card.pageRouteLink}>
                              <div
                                style={{
                                  borderRadius: "12px",
                                }}
                                className="mx-15 mb-3"
                              >
                                <img
                                  src={card.image}
                                  style={{ borderRadius: "12px" }}
                                  alt="Zeppoli image"
                                />
                              </div>
                            </Link>
                          </motion.div>
                        </div>
                      </motion.div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Gallery;
